style= require('./golf-results.styl')
if match.season
  .wrapper.column
    .controls
      section
        a(href="/matches/" + match._id + "/lineups")
          ft-button(warning) Match Setup
        each source in matchSources
          if canScrapeLineups(source)
            ft-button(warning, (click)=this.scrapeLineups(source))
              | Scrape #{source.source} #{match.uid || source.uid}
        sporty-feeds(match=match)
        sporty-match-times(match=match)
        ft-button(success,
          (click)=this.sendFeeds(),
          disabled=match.$isSubmitting
        ) Send events
        ft-button(href=`/matches/${match._id}/feeds`)
          | Download Feed

    .match
      sporty-status(match=match)
      sporty-events(match=match, validity, filterBop=filterBop)
    ft-button(success, (click)=this.editMode = !this.editMode)
      if(!this.editMode)
        | Edit stats
      else
        | Cancel
    .wrapper.column
      sporty-stats.block(
        match=match
        edit-mode=editMode
      )
    if this.editMode
      ft-button(success, (click)=this.saveStats())
        | Save

